import { uploadToWpAjax } from '../../../services/api';
import React, { useState } from 'react';
import { useConfig } from '../../ConfigContext';
import { onFileChange } from '../../../services/filesHandling';
import { ScaleLoader } from 'react-spinners';

export default function UploadArea({ callback, startLoading, style = {} }) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          ...style,
        }}
      >
        <label
          htmlFor="file-upload"
          className="cursor-pointer transition-all duration-200 text-white hover:scale-105 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{
            zIndex: 100,
            position: 'absolute',
            textAlign: 'center',
            color: 'inherit',
            overflow: 'hidden',
            width: '100%',
          }}
        >
          {isLoading ? (
            <span className="loader"></span>
          ) : (
            <>
              <span style={{ fontSize: '4.5vw' }}>+</span>
              <br />
              Nahrát fotku
            </>
          )}
        </label>
        <input
          type="file"
          accept=".jpg,.jpeg,.png,.pdf,.heic"
          id="file-upload"
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          onChange={(e) => {
            setIsLoading(true);
            onFileChange((url) => {
              callback(url);
            })(e).finally(() => {
              setIsLoading(false);
            });
          }}
          style={{
            height: '100%',
            margin: 'auto',
            zIndex: 100000,
            pointerEvents: 'initial',
          }}
        />
      </div>
    </>
  );
}
